import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'lh-screen-loader',
  template: `
    <div
      [ngClass]="{ 'screen-loader--centered': displayAsOverlay, 'screen-loader--not-centered': !displayAsOverlay }"
      class="screen-loader"
    >
      @if (text) {
        <p class="screen-loader__text">{{ text }}</p>
      }

      <p-progressSpinner styleClass="screen-loader__spinner"></p-progressSpinner>
    </div>
  `,
  styleUrls: ['./screen-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ProgressSpinnerModule, NgClass],
  encapsulation: ViewEncapsulation.None,
})
export class ScreenLoaderComponent {
  @Input() text: string = '';
  @Input() displayAsOverlay: boolean = true;
}
